<template>
  <div class="filter-user">
    <!-- 左 -->
    <div class="receive-left receive-style">
      <div class="title">
        <el-checkbox :indeterminate="noReceiveBol"
                     v-model="noCheckAll"
                     @change="handleNoCheckAllChange">未选用户</el-checkbox>
        <span>{{checkedNo}}/{{receiveData.length}}</span>
      </div>
      <div class="keywords">
        <el-input class="cus-input"
                  prefix-icon="el-icon-search"
                  v-model="keywords"
                  @input="searchReceive"
                  placeholder="请输入..."></el-input>
      </div>
      <el-checkbox-group v-model="noReceiveMan"
                         id="receiveId"
                         @change="handleNoReceiveManChange">
        <template v-for="item in receiveData">
          <el-checkbox :label="item"
                       :key="item.recommender_code">
            <span class="name">{{item.recommender_name == '' ? item.recommender_code  : item.recommender_name }}</span>
            <span>{{ item.phone }}</span>
          </el-checkbox>
        </template>

      </el-checkbox-group>
    </div>

    <div class="receive-controls">
      <el-button type="primary"
                 icon="el-icon-arrow-left"
                 @click="clickLeft"
                 :disabled="!yesReceiveArr.length"></el-button>
      <el-button type="primary"
                 @click="clickRight"
                 :disabled="!noReceiveMan.length"><i class="el-icon-arrow-right el-icon--right"></i></el-button>
    </div>

    <!-- 右 -->
    <div class="receive-right receive-style">
      <div class="title">
        <el-checkbox :indeterminate="yesReceiveBol"
                     v-model="yesCheckAll"
                     @change="handleYesCheckAllChange">已选用户</el-checkbox>
        <span>{{checkedYes}}/{{yesReceiveMan.length}}</span>
      </div>
      <div class="keywords">
        <el-input class="cus-input"
                  prefix-icon="el-icon-search"
                  v-model="checkedKeywords"
                  @input="searchCheck"
                  placeholder="请输入..."></el-input>
      </div>
      <el-checkbox-group v-model="yesReceiveArr"
                         @change="handleYesReceiveManChange">
        <template v-for="item in yesReceiveMan">
          <el-checkbox v-if="item.isShow && checkedKeywords != ''"
                       :label="item"
                       :key="item.recommender_code">
            <span class="name">{{item.recommender_name == '' ? item.recommender_code  : item.recommender_name }}</span>
            <span>{{ item.phone }}</span>
          </el-checkbox>

          <el-checkbox v-if="!item.isShow && checkedKeywords == ''"
                       :label="item"
                       :key="item.recommender_code">
            <span class="name">{{item.recommender_name == '' ? item.recommender_code  : item.recommender_name }}</span>
            <span>{{ item.phone }}</span>
          </el-checkbox>
        </template>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
import message from '../../../api/message';
import session from '../../../service/utils/sessionStorage';
export default {
  data() {
    return {
      receiveData: [],
      noReceiveBol: false,
      noCheckAll: false,
      checkedNo: 0,
      noReceiveMan: [],

      yesReceiveBol: false,
      yesCheckAll: false,
      checkedYes: 0,
      yesCacheMan: [],
      yesReceiveMan: [],
      yesReceiveArr: [],

      receiveTotalPage: 0,
      keywords: '',
      checkedKeywords: '',
      receivePagination: {
        page: 1,
        pageNumber: 20
      }
    };
  },
  watch: {
    noReceiveMan: function (newVal, oldVal) {
      this.checkedNo = newVal.length;
    },
    yesReceiveArr: function (newVal, oldVal) {
      this.checkedYes = newVal.length;
    }
  },
  mounted() {
    this.init();
  },
  destroyed() {
    const _this = this;
    window.removeEventListener('scroll', _this.handleScroll);
  },
  methods: {
    emit() {
      let params = this.yesReceiveMan.map((item) => {
        return item.recommender_code;
      });
      this.$emit('filteruser', params);
    },
    init() {
      const _this = this;
      let el = document.getElementById('receiveId');
      el.addEventListener('scroll', _this.handleScroll, true);
      this.getReceiveList();
    },
    getReceiveList() {
      let params = Object.assign(this.receivePagination, {
        keywords: this.keywords
      });
      message.getRecommenderList(params).then((res) => {
        let { list, totalPage, total } = res.data;
        list = list.map((item) => {
          item.isShow = false;
          return item;
        });
        if (this.yesReceiveMan.length) {
          for (let key of this.yesReceiveMan) {
            list = list.filter((item, index) => {
              if (item.recommender_code != key.recommender_code) {
                return item;
              }
            });
          }
        }

        if (!list.length && this.keywords == '') {
          this.receivePagination.page += 1;
          this.getReceiveList();
          return;
        }

        if (list.length < 20 && this.keywords == '') {
          this.receivePagination.page += 1;
          this.getReceiveList();
        }

        this.receiveData.push(...list);
        this.receiveTotalPage = totalPage;
      });
    },
    searchReceive() {
      this.receiveData = [];
      this.receivePagination.page = 1;
      this.getReceiveList();
    },
    searchCheck() {
      if (this.checkedKeywords != '') {
        this.yesReceiveMan = this.yesReceiveMan.map((item) => {
          if (
            item.recommender_name.search(this.checkedKeywords) != -1 ||
            item.recommender_code.search(this.checkedKeywords) != -1 ||
            item.phone.search(this.checkedKeywords) != -1
          ) {
            item.isShow = true;
          } else {
            item.isShow = false;
          }
          return item;
        });
        // console.log(this.yesReceiveMan);
      } else {
        for (let item of this.yesReceiveMan) {
          item.isShow = false;
        }
      }
    },
    clickLeft() {
      let moveKeys = JSON.parse(JSON.stringify(this.yesReceiveArr));
      console.log('22', moveKeys);
      // if (this.keywords !== '') {
      //   moveKeys = [];
      // }
      moveKeys = moveKeys.filter((item) => {
        return item.isShow;
      });
      console.log(moveKeys);
      this.receiveData.push(...moveKeys);
      let data = JSON.parse(JSON.stringify(this.yesReceiveMan));

      data.forEach((item, index) => {
        this.yesReceiveArr.forEach((key, i) => {
          if (item.recommender_code == key.recommender_code) {
            delete data[index];
            delete this.yesReceiveArr[i];
          }
        });
      });

      data = data.filter(function (val) {
        return val;
      });
      this.yesReceiveArr = this.yesReceiveArr.filter(function (val) {
        return val;
      });
      this.yesReceiveMan = data;

      this.yesCheckAll = false;
      this.yesReceiveBol = false;
      this.emit();
    },
    clickRight() {
      let moveKeys = this.noReceiveMan.map((item) => {
        if (this.checkedKeywords != '') {
          if (
            item.recommender_name.search(this.checkedKeywords) != -1 ||
            item.recommender_code.search(this.checkedKeywords) != -1 ||
            item.phone.search(this.checkedKeywords) != -1
          ) {
            item.isShow = true;
          }
        } else {
          item.isShow = false;
        }
        return item;
      });
      console.log(moveKeys);
      this.yesReceiveMan.push(...moveKeys);
      let data = JSON.parse(JSON.stringify(this.receiveData));
      data.forEach((item, index) => {
        this.noReceiveMan.forEach((key, i) => {
          if (item.recommender_code == key.recommender_code) {
            delete data[index];
            delete this.noReceiveMan[i];
          }
        });
      });
      data = data.filter(function (val) {
        return val;
      });
      this.noReceiveMan = this.noReceiveMan.filter(function (val) {
        return val;
      });
      // console.log(data);
      this.receiveData = data;
      this.sendQuery();
      this.emit();
    },
    handleNoCheckAllChange(val) {
      // console.log(val);
      this.noReceiveMan = val ? this.receiveData : [];
      this.checkedNo = val ? this.receiveData.length : 0;
      this.noReceiveBol = false;
    },
    handleNoReceiveManChange(value) {
      // console.log(this.noReceiveMan);
      let checkedCount = value.length;
      this.checkedNo = checkedCount;
      this.noCheckAll = checkedCount === this.receiveData.length;
      this.noReceiveBol =
        checkedCount > 0 && checkedCount < this.receiveData.length;
    },
    // 右
    handleYesCheckAllChange(val) {
      let data = [];
      if (this.checkedKeywords != '') {
        data = this.yesReceiveMan.filter((item) => item.isShow);
      } else {
        data = this.yesReceiveMan;
      }
      this.yesReceiveArr = val ? data : [];
      // this.checkedYes = val ? this.yesReceiveArr.length : 0;
      this.yesReceiveBol = false;
    },
    handleYesReceiveManChange(value) {
      let checkedCount = value.length;
      this.yesCheckAll = checkedCount === this.yesReceiveMan.length;
      this.yesReceiveBol =
        checkedCount > 0 && checkedCount < this.yesReceiveMan.length;
    },
    handleScroll() {
      let el = document.getElementById('receiveId');
      let sh = el.scrollHeight; // 滚动条高度
      let st = el.scrollTop; // 滚动条距离顶部的距离
      let ch = el.clientHeight; // 滚动条外容器的高度
      if (st + ch + 0.5 >= sh) {
        //到底了-业务逻辑
        this.sendQuery();
      }
    },
    sendQuery() {
      this.receivePagination.page += 1;
      if (this.receivePagination.page <= this.receiveTotalPage) {
        this.noCheckAll = false;
        this.noReceiveBol = false;
        this.noReceiveMan = [];
        this.getReceiveList();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-user {
  display: flex;
  align-items: center;
  .receive-style {
    width: 246px;
    border: 1px solid #ebeef5;
    border-radius: 10px;
    border-bottom-right-radius: 2px;
    box-sizing: border-box;
    .title {
      background-color: #f5f7fa;
      border-bottom: 1px solid #ebeef5;
      padding: 0 10px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      display: flex;
      justify-content: space-between;
      color: #707070;
    }
    .el-checkbox-group {
      height: 400px;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      padding: 0 10px;
      .el-checkbox {
        height: 30px;
      }
      ::v-deep .el-checkbox__label {
        font-size: 16px;
        .name {
          display: inline-block;
          width: 60px;
        }
      }
      &::-webkit-scrollbar-track-piece {
        background-color: #f5f7fa;
      }

      &::-webkit-scrollbar {
        width: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background: #669961;
        border-radius: 20px;
      }
    }
  }
  .receive-controls {
    margin: 0 20px;
  }
  .keywords {
    padding: 0 20px;
    .cus-input {
      ::v-deep .el-input__inner {
        height: 32px;
        font-size: 12px;
        display: inline-block;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 16px;
      }
      ::v-deep .el-input__prefix {
        font-size: 13px;
      }
    }
  }
}
</style>